import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }
const _hoisted_7 = { class: "mb-4 text-lg font-semibold text-gray-800" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mb-1 font-semibold" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "mb-1 font-semibold" }
const _hoisted_12 = { controls: "" }
const _hoisted_13 = ["src", "type"]
const _hoisted_14 = { class: "mb-2 text-lg font-semibold text-gray-800" }
const _hoisted_15 = { class: "font-semibold" }
const _hoisted_16 = {
  key: 0,
  class: "mb-2 text-sm text-gray-500"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  controls: ""
}
const _hoisted_19 = ["src", "type"]

import { ref, Ref, watch, onMounted } from 'vue';
import { useRoute, RouterLink } from 'vue-router';

import { useUiStore } from '@/stores';
import { ConnectFlowSurveyService, VaultService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { ConnectFlowSurveyModel, Permission } from '@/types';
import { getAudioFormat } from '@/utils/audio';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowSurveyDetailPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();

const survey: Ref<ConnectFlowSurveyModel | undefined> = ref(undefined);
const audioFile: Ref<string | undefined> = ref();
const questions: Ref<
    {
        label: string;
        rangeAnswer: string;
        audioFilePath?: string | null;
        audioFile?: string | null;
        textToAudio?: string | null;
    }[]
> = ref([]);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const getAudioData = async (audioFilePath: string | null | undefined) => {
    let audioData: string | undefined;

    if (audioFilePath) {
        try {
            const { data } = await VaultService.getAudioAsset(audioFilePath);
            const blob = new Blob([data], {
                type: getAudioFormat(audioFilePath),
            });

            audioData = URL.createObjectURL(blob);
        } catch (err) {
            console.error(err);
        }
    }

    return audioData;
};

const fetchConnectFlowSurvey = async (id: number) => {
    await setLoading(true);
    try {
        const response = await ConnectFlowSurveyService.get<ConnectFlowSurveyModel>(id);
        survey.value = response.data;
        audioFile.value = await getAudioData(survey.value?.audioFilePath);
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

watch([survey], async () => {
    questions.value = [];

    if (survey.value?.questions?.length) {
        for (let i = 0; i < survey.value.questions.length; i++) {
            const question = survey.value.questions[i];
            questions.value.push({
                label: question.label,
                rangeAnswer: question.rangeAnswer,
                audioFilePath: question.audioFilePath,
                audioFile: await getAudioData(question.audioFilePath),
                textToAudio: question.textToAudio,
            });
        }
    }
});

onMounted(() => {
    const surveyId = Number(route.params.id);
    if (!isNaN(surveyId)) fetchConnectFlowSurvey(surveyId);
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('connectFlowSurvey.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListConnectFlowSurvey' } }),
          (_ctx.$can(_unref(Permission).EDIT_CONNECT_FLOW_SURVEY))
            ? (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 0,
                to: {
                            name: 'EditConnectFlowSurveyById',
                            params: {
                                id: _unref(route).params.id,
                            },
                        },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (survey.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_UiPanel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('connectFlowSurvey.labels.name')), 1),
                  _createElementVNode("p", null, _toDisplayString(survey.value.name), 1)
                ])
              ]),
              _createVNode(_component_UiAuditStatusInfo, {
                "model-value": survey.value,
                class: "bt-1 mt-4 border-t border-gray-300 pt-2"
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_UiPanel, null, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t('connectFlowSurvey.view.section.initialMessage.title')), 1),
              (survey.value.textToAudio)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('connectFlowSurvey.labels.textToAudio')), 1),
                    _createElementVNode("p", null, _toDisplayString(survey.value.textToAudio), 1)
                  ]))
                : _createCommentVNode("", true),
              (audioFile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('connectFlowSurvey.labels.audio')), 1),
                    _createElementVNode("audio", _hoisted_12, [
                      _createElementVNode("source", {
                        src: audioFile.value,
                        type: _unref(getAudioFormat)(survey.value.audioFilePath || '')
                      }, null, 8, _hoisted_13)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_UiPanel, null, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t('connectFlowSurvey.view.section.questions.title')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "bt-1 border-t py-2"
                }, [
                  _createElementVNode("h4", _hoisted_15, _toDisplayString(question.label), 1),
                  (question.rangeAnswer)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.$t('connectFlowSurvey.view.section.questions.labels.scoreRange')) + ": " + _toDisplayString(question.rangeAnswer), 1))
                    : _createCommentVNode("", true),
                  (question.textToAudio)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(question.textToAudio), 1))
                    : _createCommentVNode("", true),
                  (question.audioFile)
                    ? (_openBlock(), _createElementBlock("audio", _hoisted_18, [
                        _createElementVNode("source", {
                          src: question.audioFile,
                          type: _unref(getAudioFormat)(question.audioFilePath || '')
                        }, null, 8, _hoisted_19),
                        _cache[0] || (_cache[0] = _createTextVNode(" Seu navegador não suporta o elemento de áudio. ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})